import { useLocale } from '../hooks/useLocale'
import styles from './About.module.css'

export default function About() {
  const { t } = useLocale()

  return (
    <section className={styles.about} id="about" aria-labelledby="about-title">
      <div className={styles.container}>
        <h2 className={styles.title} id="about-title">{t('about.title')}</h2>
        <div className={styles.content}>
          <p className={styles.mission}>{t('about.mission')}</p>
          <p className={styles.founding}>{t('about.founding')}</p>
          <p className={styles.description}>{t('about.description')}</p>
          <p className={styles.approach}>{t('about.approach')}</p>
        </div>
      </div>
    </section>
  )
}
